export const COLOR = {
  YELLOW: '#fad61d',
  MUSTAD: '#e19720',
  RED: '#f62d14',
  BURGUNDY: '#811E09',
  BLACK: '#000000',
};
